import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  { path: '', loadComponent: () => import('./main/website/home/home.component').then(m => m.HomeComponent) },
  { path: 'business', loadComponent: () => import('./main/website/business/business.component').then(m => m.BuildingsComponent) },
  { path: 'offices', loadComponent: () => import('./main/website/offices/offices.component').then(m => m.BuildingsComponent) },
  { path: 'buildings', loadComponent: () => import('./main/website/buildings/buildings.component').then(m => m.BuildingsComponent) },
  // {path:'buildings',loadChildren:()=>import('./main/pages/buildings/buildings.module').then(m=>m.buildingsModule)},
  // { path: '**', component: PageNotFoundComponent }
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { } 
